import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadOperationTypes = async () => {
  try {
    const response = await Axios.get('operation-types');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

const loadOneOperation = async (name) => {
  try {
    const respnse = await Axios.get('operation-types/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadOperationType = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/operation-types');
        const responseData = await response.data;
        return {...responseData, operation: {}};
        
      default:
        const data = await loadOneOperation(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const useOperationTypes = () => {

  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('operation-types', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('operation_response', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (name, data, success) => {
    try {
      const respnse = await Axios.put('operation-types/'+name, data);
      const responseData = await respnse.data;
      success(responseData.message);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};


export default useOperationTypes;